import { atom } from "jotai";

export const priceAtom = atom({});
export const isPriceLoadingAtom = atom(false);
export const promoCodeAtom = atom("");
export const selectedCompaniesAtom = atom([]);
export const searchCompanyTermsAtom = atom("");
